define("Ames.Autopilot.Autopilot", [], function () {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var self = this;
      var layout = container.getComponent("Layout");
      if (layout) {
        layout.on("afterShowContent", function () {
          self.loadScript();
        });
      }
    },
    loadScript: function loadScript() {
      (function () {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src =
          "//cdn.bc0a.com/autopilot/f00000000303991/autopilot_sdk.js";
        var firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode.insertBefore(script, firstScript);
      })();
    },
  };
});
